import React from 'react';
import styled from 'styled-components';

import {
  getNameFromVendor,
  vendorTypeToReadableSEOType,
  formatLocation,
  generateImageFromCDN,
} from '@sayido/utils';

const AVATAR_SIZE = 140;

const AvatarWrapper = styled.div`
  margin: -50px auto 0;
`;

const Avatar = styled.img`
  border: solid 4px #fff;
  border-radius: ${AVATAR_SIZE}px;
  display: block;
  height: ${AVATAR_SIZE}px;
  width: ${AVATAR_SIZE}px;
`;

const Img = styled.img`
  display: block;
`;

const NoImg = styled.div`
  background: #f8f8f8;
  height: 50px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Name = styled.h1`
  font-family: var(--secondary-font-family);
  margin: 12px 0 6px;
  font-size: 1.4em;
`;

const Type = styled.h2`
  font-size: 16px;
  margin: 0 0 12px;
`;

const Wrapper = styled.a`
  background: #fff;
  border-radius: 8px;
  color: #444;
  display: block;
  max-width: 300px;
  overflow: hidden;
  padding-bottom: 20px;
  text-align: center;
  text-decoration: none;
  width: 100%;

  &:hover {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.1s ease-in-out;

    ${Name} {
      text-decoration: underline;
    }
  }

  ${Img} {
    max-width: 100%;
  }

  @media (max-width: 500px) {
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.1);
  }
`;

const Location = styled.div`
  color: #888;
  font-size: 13px;
`;

export const VendorCard = ({ vendor = {}, source, medium, campaign }) => {
  const originalImage =
    vendor?.image ||
    // Use this property to get image when vendors came from new API.
    vendor?.main_photo ||
    (vendor.images && vendor.images[0] && vendor.images[0].original);
  const image = generateImageFromCDN(originalImage, {
    width: 300,
    aspect_ratio: '4:3',
  });
  const level1 = formatLocation(vendor.country, vendor.area_level_1);
  const level2 = formatLocation(vendor.country, vendor.area_level_2);
  const baseURL = vendor.url || `/wedding-${vendor.type}/all/all/${vendor.slug}`;
  const url = `${baseURL}${source || medium ? '?' : ''}${
    source ? `utm_source=${source}&` : ''
  }${medium ? `utm_medium=${medium}&` : ''}${
    campaign ? `utm_campaign=${campaign}&` : ''
  }`;

  return (
    <Wrapper
      href={vendor.slug ? url : '#'}
      target="_blank"
      rel="noopener noreferrer"
    >
      {!!image ? <Img src={image} /> : <NoImg />}
      <Body>
        {!!vendor.contact_image && !!vendor.contact_image.original && (
          <AvatarWrapper>
            <Avatar
              src={generateImageFromCDN(vendor.contact_image.original, {
                width: AVATAR_SIZE,
                height: AVATAR_SIZE,
                // fit: 'facearea',
              })}
            />
          </AvatarWrapper>
        )}
        <Name>{getNameFromVendor(vendor.contact)}</Name>
        <Type>{vendorTypeToReadableSEOType(vendor.type, false)}</Type>
        <Location>
          {level2 && `${level2}, `}
          {level1}
        </Location>
      </Body>
    </Wrapper>
  );
};
